var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceComfort5Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8361_2362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.26801 9.26801 2 17 2H29C36.732 2 43 8.26801 43 16V28C43 35.732 36.732 42 29 42H17C9.26801 42 3 35.732 3 28V16Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6665 28.3333C23.8778 28.4917 24.1237 28.5977 24.3839 28.6425C24.6442 28.6872 24.9114 28.6695 25.1635 28.5908C25.4155 28.512 25.6453 28.3745 25.8338 28.1896C26.0223 28.0046 26.1641 27.7775 26.2476 27.527C26.3312 27.2764 26.3539 27.0096 26.3141 26.7486C26.2743 26.4875 26.173 26.2396 26.0186 26.0254C25.8642 25.8112 25.661 25.6367 25.426 25.5163C25.1909 25.396 24.9306 25.3333 24.6665 25.3333H14.6665",
    stroke: "#0092B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5832 18.6666C27.7962 18.3825 28.0784 18.1576 28.4028 18.0132C28.7273 17.8688 29.0832 17.8098 29.4369 17.8417C29.7906 17.8736 30.1303 17.9953 30.4237 18.1954C30.717 18.3955 30.9544 18.6673 31.1132 18.9849C31.272 19.3025 31.347 19.6555 31.3311 20.0102C31.3151 20.365 31.2087 20.7098 31.022 21.0119C30.8353 21.3139 30.5745 21.5633 30.2643 21.7362C29.9542 21.9091 29.605 21.9999 29.2498 21.9999H14.6665",
    stroke: "#0092B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1665 15.6666C21.3778 15.5081 21.6237 15.4022 21.8839 15.3574C22.1442 15.3126 22.4114 15.3303 22.6635 15.4091C22.9155 15.4878 23.1453 15.6253 23.3338 15.8103C23.5223 15.9952 23.6641 16.2223 23.7476 16.4729C23.8312 16.7234 23.8539 16.9902 23.8141 17.2513C23.7743 17.5123 23.673 17.7602 23.5186 17.9744C23.3642 18.1887 23.161 18.3632 22.926 18.4835C22.6909 18.6038 22.4306 18.6666 22.1665 18.6666H14.6665",
    stroke: "#0092B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8361_2362",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8361_2362"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8361_2362"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8361_2362",
    result: "effect2_dropShadow_8361_2362"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8361_2362",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceComfort5Icon);
export default __webpack_public_path__ + "static/media/enhance_comfort_5_icon.88a90703f18e88b569601eed41ae9d52.svg";
export { ForwardRef as ReactComponent };